import styled from 'styled-components/macro';
import { FilterOutlined } from '@ant-design/icons';

export const StyledFilterIcon = styled(FilterOutlined)`
  font-size: 20px;
  color: ${(props: { $iconColor?: string }) => props.$iconColor};
`;
